define([
    "dojo/_base/declare",
    "mw-form/RadioButtonMenuItem",
    "../mixins/property/TypeMixin",
    "../mixins/property/DescriptionOverrideMixin",
    "../mixins/property/TextOverrideMixin",
    "../mixins/property/ButtonGroupMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, RadioButtonMenuItem, TypeMixin, DescriptionOverrideMixin, TextOverrideMixin,
             ButtonGroupMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([RadioButtonMenuItem, TypeMixin, DescriptionOverrideMixin,
        TextOverrideMixin, ButtonGroupMixin]), {
        visualFamily: "default",
        eligibleForParentAdditionToQAB: true, // Property used to know that we need to add the parent of this widget to QAB

        postCreate: function () {
            this.inherited(arguments);
            this.radioButton.set("visualFamily", "default");
        },

        _qeSetChecked: function(check) {
            this.set("checked", check, true);
        }
    });
});
